import { getCommerceDataConfig, type CommerceDataConfig } from './config';

// Same throw-by-name contract as `injected()` in injected-billing.ts: a member
// the app never injected would otherwise reach the call as `undefined` and
// blow up with no member in the message. Kept private here — the module's
// version stays unexported so the /data door surface pin stays exact.
const injected = <K extends keyof CommerceDataConfig>(
  member: K
): NonNullable<CommerceDataConfig[K]> => {
  const value = getCommerceDataConfig()[member];
  if (value === undefined) {
    throw new Error(
      `[commerce/data] \`${member}\` is not configured — the app injects it at ` +
        'src/composition/hosts/commerce/commerce-data-wiring.ts (ruling 65); a test exercising this ' +
        'reader must configure a double for that member first.'
    );
  }
  return value;
};

export function openQuotaExceededUpgradeModal() {
  if (injected('isEvidenceLaunchTrialAndUpgradeFlowsEnabled')() === true) {
    injected('openClinicianUpgradeModal')();
  } else {
    injected('openUpgradeProModal')();
  }
}
